import { render } from "./IdleDialog.vue?vue&type=template&id=f99e7a18&scoped=true"
import script from "./IdleDialog.vue?vue&type=script&lang=js"
export * from "./IdleDialog.vue?vue&type=script&lang=js"

import "./IdleDialog.vue?vue&type=style&index=0&id=f99e7a18&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f99e7a18"]])

export default __exports__